export const successAction = action => `${action}_SUCCESS`;
export const failureAction = action => `${action}_FAILURE`;

export const GET_PERMISSION = 'GET_PERMISSION';

export const START_SESSION = 'START_SESSION';

export const GET_DIRECTIONS = 'GET_DIRECTIONS';
export const GET_EVENT_TYPES = 'GET_EVENT_TYPES';
export const GET_RESPONSIBLE = 'GET_RESPONSIBLE';
export const GET_GAMES = 'GET_GAMES';
export const GET_PLATFORMS = 'GET_PLATFORMS';
export const GET_VERSIONS = 'GET_VERSIONS';
export const GET_COLUMNS = 'GET_COLUMNS';
export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export const GET_CHANNELS = 'GET_CHANNELS';
export const GET_CLASS_TAGS = 'GET_CLASS_TAGS';
export const GET_TECH_TAGS = 'GET_TECH_TAGS';
export const GET_TYPE_TAGS = 'GET_TYPE_TAGS';
export const GET_EXTRA_FIELDS_LIST = 'GET_EXTRA_FIELDS_LIST';

export const CREATE_EVENT = 'CREATE_EVENT';
export const GET_EVENT = 'GET_EVENT';
export const CLEAN_EVENT = 'CLEAN_EVENT';
export const UPDATE_EVENT = 'UPDATE_EVENT';

export const GET_EVENTS = 'GET_EVENTS';
export const CLEAN_EVENTS = 'CLEAN_EVENTS';

export const GET_FORM_DIRECTIONS = 'GET_FORM_DIRECTIONS';
export const GET_FORM_EVENT_TYPES = 'GET_FORM_EVENT_TYPES';
export const GET_FORM_GAMES = 'GET_FORM_GAMES';
export const GET_FORM_PLATFORMS = 'GET_FORM_PLATFORMS';
export const GET_FORM_RESPONSIBLE = 'GET_FORM_RESPONSIBLE';
export const GET_FORM_VERSIONS = 'GET_FORM_VERSIONS';
export const GET_FORM_CHANNELS = 'GET_FORM_CHANNELS';
export const GET_FORM_CLASS_TAGS = 'GET_FORM_CLASS_TAGS';
export const GET_FORM_TECH_TAGS = 'GET_FORM_TECH_TAGS';
export const GET_FORM_TYPE_TAGS = 'GET_FORM_TYPE_TAGS';

export const GET_EXTRA_CHANNEL = 'GET_EXTRA_CHANNEL';
export const GET_EXTRA_CLASS_TAG = 'GET_EXTRA_CLASS_TAG';
export const GET_EXTRA_TEACH_TAG = 'GET_EXTRA_TEACH_TAG';
export const GET_EXTRA_TYPE_TAG = 'GET_EXTRA_TYPE_TAG';
